import type { ListQuery } from '#shared/types/goliath/goliath.types';

// TODO: import this method in all relevant components instead of copy/paste

function calculateLastModified(offers: ListQuery['offers'], buildDate: Date) {
  let lastModified: Date | null = null;
  if (offers?.entries && Array.isArray(offers.entries)) {
    offers.entries.forEach((offer) => {
      const updatedAt = new Date(offer?.updatedAt);
      if (updatedAt > (lastModified ?? 0)) {
        lastModified = updatedAt;
      }
    });
  }
  return (lastModified ?? buildDate).toUTCString();
}

export const calculateLastModifiedOffer = (offer: Offer, buildDate: Date) => {
  let lastModified: Date = buildDate;
  const updatedAt = new Date(offer.updatedAt);
  if (updatedAt > lastModified) {
    lastModified = updatedAt;
  }
  return lastModified.toUTCString();
};

export default calculateLastModified;
